import gql from 'graphql-tag'

export default gql`
	mutation deleteProductAddition($id: ID!) {
		cashAssist {
			deleteProductAddition(id: $id) {
				id
			}
		}
	}
`
